module.exports = ".confirm-delete-button {\n  color: #fe2851;\n  margin-left: 1em; }\n\n.confirm-modal {\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal.component.scss
// module id = ./src/app/shared/modal/modal.component.scss
// module chunks = main